import React, { useState } from "react";
import MonthlyReportList from "./MonthlyReportsList"; // Plural
import MonthlyReportForm from "./MonthlyReportForm";

const MonthlyReportsPage = () => {
  const [activeTab, setActiveTab] = useState("list");

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">
          <i className="bi bi-folder-fill me-2"></i>
          Monthly Reports
        </h4>
        <span className="badge bg-warning text-dark">
          <i className="bi bi-shield-lock me-1"></i>
          HIPAA Protected
        </span>
      </div>

      <div className="alert alert-info mb-3">
        <i className="bi bi-info-circle me-2"></i>
        <strong>HIPAA Compliance Notice:</strong> This section contains
        Protected Health Information (PHI). All access is logged and monitored.
        Only authorized personnel should access these reports. Unauthorized
        access may result in civil and criminal penalties under HIPAA
        regulations.
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            <i className="bi bi-list-ul me-2"></i>
            Report List
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "create" ? "active" : ""}`}
            onClick={() => setActiveTab("create")}
          >
            <i className="bi bi-plus-circle me-2"></i>
            Create Report
          </button>
        </li>
      </ul>

      <div className="tab-content">
        {activeTab === "list" && <MonthlyReportList />}
        {activeTab === "create" && (
          <MonthlyReportForm onSuccess={() => setActiveTab("list")} />
        )}
      </div>

      <div className="mt-4 p-3 bg-light rounded">
        <h6 className="mb-2">
          <i className="bi bi-shield-check me-2"></i>
          Security Information
        </h6>
        <small className="text-muted">
          <ul className="mb-0">
            <li>All data is encrypted using AES-256 encryption</li>
            <li>Access logs are maintained for audit purposes</li>
            <li>
              Electronic signatures are legally binding under the E-Sign Act
            </li>
            <li>Reports are stored in HIPAA-compliant cloud storage</li>
          </ul>
        </small>
      </div>
    </div>
  );
};

export default MonthlyReportsPage;
